import restoreConversations from './restoreConversations';
import restoreItems from './restoreItems';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
export default function restoreMailListRows(rowKeys, originalTableViewId, actionSource) {
    var tableView = listViewStore.tableViews.get(originalTableViewId);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            restoreConversations(rowKeys, originalTableViewId);
            break;
        case 1 /* Message */:
            restoreItems(rowKeys, originalTableViewId);
            break;
    }
}
//# sourceMappingURL=restoreMailListRows.js.map